import type { EditAddressRequestBody } from 'src/app/hooks/data/deliveryAddress';
import type { DeliveryAddress } from 'src/app/types';

export const editDeliveryAddressRequestBodyTransform = (data: DeliveryAddress): EditAddressRequestBody => {
  return {
    id: data.id!,
    address: data.address!,
    addressTwo: data.addressTwo,
    instructions: data.instructions,
    isDoorman: data.isDoorman ?? false,
    zipCode: data.zipCode!,
  };
};
